import React from 'react';

interface MediaControlButtonProps {
  visible: boolean;
  isPlaying: boolean;
  isEnded: boolean;
  onClick: () => void | Promise<void>;
  position?: 'top-right' | 'bottom-right';
  offset?: number; // pixels
  className?: string;
  ariaLabels?: {
    play?: string;
    pause?: string;
    replay?: string;
  };
}

export function MediaControlButton({
  visible,
  isPlaying,
  isEnded,
  onClick,
  position = 'bottom-right',
  offset = 16,
  className,
  ariaLabels
}: Readonly<MediaControlButtonProps>) {
  if (!visible) return null;

  const ariaLabel =
    isEnded && !isPlaying
      ? ariaLabels?.replay || 'Play again'
      : isPlaying
      ? ariaLabels?.pause || 'Pause video'
      : ariaLabels?.play || 'Play video';

  const posStyle: React.CSSProperties =
    position === 'top-right'
      ? { top: offset, right: offset }
      : { bottom: offset, right: offset };

  return (
    <button
      type="button"
      className={`absolute z-10 flex h-10 w-10 items-center justify-center rounded-full bg-brand-base text-brand-strongest shadow-md ${
        className ?? ''
      }`}
      aria-label={ariaLabel}
      onClick={onClick}
      style={posStyle}
    >
      {isPlaying ? (
        <svg
          viewBox="0 0 24 24"
          className="fill-current h-6 w-6 cursor-pointer"
          aria-hidden="true"
        >
          <rect x="6" y="4" width="4" height="16" rx="1" />
          <rect x="14" y="4" width="4" height="16" rx="1" />
        </svg>
      ) : (
        <svg
          viewBox="0 0 24 24"
          className="fill-current h-6 w-6 cursor-pointer"
          aria-hidden="true"
        >
          <path d="M8 5v14l11-7z" />
        </svg>
      )}
    </button>
  );
}

export default MediaControlButton;
